import React from 'react';

import FormRow from 'components/FormRow';
import { useGenerateBeneficialOwnerFields } from 'pages/operationPortal/CompaniesDetails/AssiciatedPerson/components/beneficialOwners/formFields/useGenerateBeneficialOwnerFields';
import { AssociatedPersonMode } from 'pages/operationPortal/CompaniesDetails/AssiciatedPerson/types';

export type BeneficialOwnerFieldsProps = {
  mode: AssociatedPersonMode;
  prefix?: string;
};

const BeneficialOwnerFields = ({ mode, prefix }: BeneficialOwnerFieldsProps) => {
  const fields = useGenerateBeneficialOwnerFields(mode, prefix);

  return (
    <>
      <FormRow>
        {fields.firstName}
        {fields.lastName}
      </FormRow>
      <FormRow>
        {fields.nationality}
        {fields.capitalOrVotingRightsPercentage}
      </FormRow>
      <FormRow>
        {fields.placeOfResidence}
        {fields.countryOfResidence}
      </FormRow>
      <FormRow>
        {fields.birthPlace}
        {fields.birthDate}
      </FormRow>
      <FormRow>{fields.fictional}</FormRow>
    </>
  );
};

export default BeneficialOwnerFields;
